<template>
  <div class="wrapper flex" :style="{ height: domHeight + 'px' }">
    <v-sidebar :dom-height="domHeight"></v-sidebar>
    <div>
      <v-head></v-head>
      <div id="content-box" class="content-box" :style="{ height: domHeight - 70 + 'px' }">
        <keep-alive :include="tagsList">
          <router-view></router-view>
        </keep-alive>
        <el-backtop target=".wrapper"></el-backtop>
      </div>
    </div>
  </div>
</template>

<script>
import vHead from './Header.vue';
import vSidebar from './Sidebar.vue';
import vTags from './Tags.vue';
import bus from './bus';
import request from '@/utils/request';
export default {
  data() {
    return {
      tagsList: [], //需要缓存的页面
      collapse: false,
      domHeight: 100
    };
  },
  components: {
    vHead,
    vSidebar,
    vTags
  },
  mounted() {
    const that = this;
    // var params = this.getParamsFromURL(window.location.href);
    // sessionStorage.setItem('gatewayToken', params.token);
    this.domHeight = window.innerHeight;
    window.addEventListener('resize', () => {
      this.domHeight = window.innerHeight;
    });
  },
  created() {
    this.validateSession(); //验证session
    // 折叠栏的显示隐藏
    // bus.$on('collapse-content', (msg) => {
    //   this.collapse = msg;
    // });
    // 只有在标签页列表里的页面才使用keep-alive，即关闭标签之后就不保存到内存中了。
    bus.$on('aliveTags', (msg) => {
      this.tagsList = msg;
    });
  },
  beforeDestroy(){},
  methods: {
    getParamsFromURL(url) {
      if ('undefined' == url) {
        return {};
      }
      let paraString = url.substring(url.indexOf('?') + 1, url.length).split('&');
      let paraObj = {};
      for (let i = 0; i < paraString.length; i++) {
        let j = paraString[i];
        paraObj[j.substring(0, j.indexOf('='))] = j.substring(j.indexOf('=') + 1, j.length);
      }
      return paraObj;
    },
    // 验证token
    validateToken() {     
      const clinicInfoJy = JSON.parse(sessionStorage.user);
      if (clinicInfoJy && clinicInfoJy.token) {
        const params = {
          token: clinicInfoJy.token
        };
        request.post('/server/11.php', params).then((res) => {
          if (res.hsp_name && res.hsp_code) {
            console.log('token 可以使用');
          } else {
            console.log('token  不可以使用');
            this.$router.push({ path: '/login', query: {} });
          }
        });
      } else {
        this.$router.push({ path: '/login', query: {} });
        console.log('抱歉token失效');
      }
    },
    // 验证session是否存在
    validateSession() {    
      if (!sessionStorage.getItem('user')) {
        this.$message.error('抱歉，请先登录');
        this.$router.push({ path: '/login', query: {} });
      }
    }
  }
};
</script>

<style scoped>
.content-box {
  width: calc(100vw - 148px);
  padding: 10px;
  /* padding-right: 0; */
  overflow-y: auto;
}
</style>
